<script setup lang="ts">
import bg1 from "@/assets/images/backgroundServices/carousel/img1CD.png";
import bg2 from "@/assets/images/backgroundServices/carousel/img2.png";
import bg3 from "@/assets/images/backgroundServices/carousel/img3.png";
// step-icons
import icon1 from "@/assets/images/backgroundServices/detailsIcon/step-icons.svg";
import icon2 from "@/assets/images/backgroundServices/detailsIcon/step-icons3.svg";
import icon3 from "@/assets/images/backgroundServices/detailsIcon/step-icons4.svg";
// details
import app_registration from "@/assets/images/backgroundServices/detailsIcon/app_registration.svg";
import palette from "@/assets/images/backgroundServices/detailsIcon/palette.svg";
import forum from "@/assets/images/backgroundServices/detailsIcon/forum.svg";
import browser_updated from "@/assets/images/backgroundServices/detailsIcon/browser_updated.svg";

// Carousel data
const images = [bg1, bg2, bg3];

// wrapp-steps data
const steps = [
	{
		icon: icon1,
		title: "Step 1",
		subTitle: "First week",
		text: "Initial team and product overview. Introductory meeting followed by a questionnaire to help streamline the process.",
	},
	{
		icon: icon2,
		title: "Step 2",
		subTitle: "First month",
		text: "Follow up meetings, wireframe and design presentations.",
	},
	{
		icon: icon3,
		title: "Step 3",
		subTitle: "Three months",
		text: "Delivery of finished design work after client confirmation. Delivery of editable design files and a comprehensive design document.",
	},
];

// detailsBottom data
const title = ref("What does consulting and design entail?");
const items = ref([
	{
		icon: app_registration,
		txt: "C&D entails the creation of design files and documents tailored to your needs. Assistance by our experts during the process and final delivery.",
	},
	{
		icon: palette,
		txt: "Design can be provided outside of boxed development solutions and delivered independently.",
	},
	{
		icon: forum,
		txt: "Link to questionnaire.",
		link: "https://docs.google.com/forms/d/13pALsNb9YXqeT6aBHizGjQqMtwetKXMp2r_cU0J1bpA/viewform?edit_requested=true",
	},
	{
		icon: browser_updated,
		txt: "Our typical design document is shown in the downloadable template but can be adjusted to fit specific needs.",
	},
]);
const price = ref("3000-12000€");
const price_txt = ref([
	"for product design work depending on complexity.",
	"Timeframe for specific steps is given as an example and depends mostly on client communication and availability.",
]);

onMounted(() => {
	setTimeout(() => {}, 100);
});
onUnmounted(() => {});
</script>
<template>
	<div class="service-details-page">
		<Carousel :images="images" />
		<wrapp-steps :steps="steps" />
		<detailsBottom
			:title="title"
			:items="items"
			:price="price"
			:price_txt="price_txt"
		/>
	</div>
</template>
<style lang="scss">
.service-details-page {
	background-image: url("@/assets/images/backgroundServices/whiteback.png");
	background-position: center top;
	background-repeat: no-repeat;
	// background-size: 100% auto; // cover
	background-size: cover;
	margin-top: 100px;
	min-height: calc(100vh - 100px);
}

@media screen and (width <= 768px) {
	.service-details-page {
		// set style
	}
}
</style>
